import { Drawer } from 'antd';
import { useEffect, useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { RootState } from '../../modules';
import WorkRecordDetailComponent from '../../components/work-records/WorkRecordDetailComponent';
import WorkRecordEditDrawer from './WorkRecordEditDrawer';
import { getWorkRecordDetailAsync } from '../../modules/work-records';

interface WorkRecordDetailDrawerProps {
  enterpriseId: string;
  projectId: string;
  workRecordId?: string;
  visibleDetailDrawer: boolean;
  onClose: () => void;
}

function WorkRecordDetailDrawer({
  enterpriseId,
  projectId,
  workRecordId,
  visibleDetailDrawer,
  onClose,
}: WorkRecordDetailDrawerProps) {
  const [visibleEditDrawer, setVisibleEditDrawer] = useState<boolean>(false);
  const onCloseEditDrawer = () => {
    setVisibleEditDrawer(false);
  };

  const workRecord = useSelector(
    (state: RootState) => state.workRecords.workRecord.data,
  );
  const dispatch = useDispatch();

  useEffect(() => {
    dispatch(
      getWorkRecordDetailAsync.request({
        enterpriseId: enterpriseId,
        projectId: projectId,
        workRecordId: workRecordId,
      }),
    );
  }, [enterpriseId, projectId, workRecordId, dispatch]);

  // const showDeleteConfirm = () => {
  //   confirm({
  //     title: '작업일보을 삭제하시겠습니까?',
  //     icon: <ExclamationCircleOutlined rev={undefined} />,
  //     // content: 'Some descriptions',
  //     okText: '예',
  //     okType: 'danger',
  //     cancelText: '아니오',
  //     onOk() {
  //       console.log('OK');
  //       dispatch(
  //         deleteWorkRecordAsync.request({
  //           enterpriseId: enterpriseId,
  //           projectId: projectId,
  //           workRecordId: workRecordId,
  //         }),
  //       );
  //       onClose();
  //     },
  //     onCancel() {
  //       console.log('Cancel');
  //       onClose();
  //     },
  //   });
  // };

  // const openDrawer = (menyType: string) => {
  //   console.log(menyType);
  //   if (menyType === '1') {
  //     setVisibleEditDrawer(true);
  //   } else if (menyType === '2') {
  //     console.log('delete');
  //     showDeleteConfirm();
  //   }
  // };

  return (
    <>
      <Drawer
        width={800}
        placement="right"
        closable={false}
        onClose={onClose}
        open={visibleDetailDrawer}
      >
        {visibleDetailDrawer && workRecord && (
          <>
            <WorkRecordDetailComponent
              workRecord={workRecord}
              // openDrawer={openDrawer}
              moveToEditPage={() => setVisibleEditDrawer(true)}
            />
          </>
        )}
      </Drawer>
      <WorkRecordEditDrawer
        enterpriseId={enterpriseId}
        projectId={projectId}
        visible={visibleEditDrawer}
        onClose={onCloseEditDrawer}
        workRecordId={workRecordId}
      />
    </>
  );
}

export default WorkRecordDetailDrawer;
